export default __webpack_public_path__ + "static/media/risk-analysis-report-icon.98a2001d.svg";